import { useCallback } from 'react';

import {
  UserConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

const useConnectionSuccess = () => {
  const {
    selectedConnection,
    handleUpdateOverlayMode,
    handleReload,
    handleUpdateUserConnectionModalScreen,
  } = useSFConnectionState();

  const handleDone = useCallback(() => {
    handleUpdateUserConnectionModalScreen(
      UserConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
    handleUpdateOverlayMode('none');
    handleReload();
  }, [
    handleReload,
    handleUpdateOverlayMode,
    handleUpdateUserConnectionModalScreen,
  ]);

  return {
    handleDone,
    connectionName: selectedConnection?.name ?? '',
  };
};

export { useConnectionSuccess };
